import { ReadTaskSummaryData } from '@common/config/api/client'
import { ExpandLessRounded, ExpandMoreRounded } from '@mui/icons-material'
import { Collapse, MenuItem, MenuList, Stack, Typography } from '@mui/material'

interface EcrfMenuProps {
  selectedItem: string
  setSelectedItem: (item: string) => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  timepoints: ReadTaskSummaryData['timepoints']
}

export default function EcrfMenu({ selectedItem, setSelectedItem, isOpen, setIsOpen, timepoints }: EcrfMenuProps) {
  const handleExpandeClick = () => {
    const newIsOpen = !isOpen
    setIsOpen(newIsOpen)

    if (newIsOpen && timepoints.length > 0) {
      setSelectedItem(`timepoint_${0}`)
    } else {
      setSelectedItem('ecrf')
    }
  }

  return (
    <MenuList>
      <MenuItem onClick={() => setSelectedItem('ecrf')} selected={selectedItem === 'ecrf'}>
        <Typography variant="body1">eCRF</Typography>
      </MenuItem>
      <MenuItem onClick={handleExpandeClick} selected={selectedItem === 'timepoint_eform'}>
        <Stack direction="row" spacing={1}>
          {isOpen ? (
            <ExpandLessRounded
              sx={{
                width: 24,
                height: 24,
                color: 'text.secondary',
              }}
            />
          ) : (
            <ExpandMoreRounded
              sx={{
                width: 24,
                height: 24,
                color: 'text.secondary',
              }}
            />
          )}
          <Typography variant="body1">Timepoint eForm</Typography>
        </Stack>
      </MenuItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        {timepoints.map(
          (timepoint, index) =>
            timepoint.timepoint_eform_definition && (
              <MenuItem
                key={index}
                onClick={() => setSelectedItem(`timepoint_${index}`)}
                selected={selectedItem === `timepoint_${index}`}
                sx={{ pl: 6.5, cursor: 'pointer' }}
              >
                <Typography variant="body1">{timepoint.timepoint_name}</Typography>
              </MenuItem>
            ),
        )}
      </Collapse>
    </MenuList>
  )
}
